var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-group tw-flex tw-h-14 tw-justify-center tw-rounded tw-border tw-border-neutral-300 tw-text-primary-grey tw-transition-colors hover:tw-cursor-pointer hover:tw-border-sky-500 hover:tw-text-sky-500 active:tw-border-primary-blue-dark"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }